export default __webpack_public_path__ + "static/mode-multiplayer-dark-48d0f6016099dafde6e3306b10f2f45e.png";